import { render, staticRenderFns } from "./LancamentoAvulsoList.vue?vue&type=template&id=31949aa4"
import script from "./LancamentoAvulsoList.vue?vue&type=script&lang=js"
export * from "./LancamentoAvulsoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports